import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/helpers';
import '../../pdf/draw/cut';

/**
 * Multiplication - Multiplication strip cards with images
 *
 * Layout: 10 portrait pages, one image per page.
 * Each page: 10 vertical strips with the image as background,
 * and multiplication facts (A label, B label, result) on each strip.
 *
 * Migrated from C# EduFrame.Img10.Generators.Multiplication
 */
export class Multiplication implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }
  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(20);
    const sz = PdfSize.A4.width - 2 * margin;
    const originX = margin;
    const originY = (PdfSize.A4.height - sz) / 2;
    const rect = new PdfRect(originX, originY, sz, sz);
    const oneW = sz / 10;

    for (let i = 0; i < Math.min(opts.list.length, 10); i++) {
      const page = pdf.addPage();

      // Background image
      page.drawImageFit(opts.list[i].image, rect);

      for (let j = 0; j < 10; j++) {
        const r = new PdfRect(originX + j * oneW, originY, oneW, sz);

        page.cutCross(new PdfPoint(r.left, r.top), false, true);

        const aRect = new PdfRect(r.left, r.top, r.width, oneW);
        const bRect = new PdfRect(r.left, r.bottom - oneW * 2, r.width, oneW);
        const labelRect = new PdfRect(r.left, r.bottom - oneW, r.width, oneW);

        page.drawFillStringCenter(opts.list[i].label, GUtil.baseFont, PdfBrush.Black, aRect, true);
        page.drawFillStringCenter(opts.list[i].label, GUtil.baseFont, PdfBrush.Black, bRect, true);
        page.drawFillStringCenter(
          `${(i + 1) * (j + 1)}`,
          GUtil.baseFont,
          PdfBrush.Black,
          labelRect,
          true
        );
      }

      page.drawRectangle(GUtil.basePen, null, rect);

      page.cutCross(rect.topLeft, true, false);
      page.cutCross(rect.bottomRight);
    }
  }
}
